import React from 'react';
import classNames from 'classnames';
import LeaderboardRScore from './leaderboard-r-score';
import { viewTypes, cellTypes } from '../enums';

const LeaderboardCellPlayerTitle = (
    {
        view,
        toggleRScore,
        sortingHandlerProps,
        processingState,
    }
) => {
    const isActive = processingState.sortingType === cellTypes.PLAYER;
    const stateCss = classNames({
        'is-active': isActive,
        'is-top': isActive && processingState.isSortingAscending
    });

    return (
        <div
            className={`leaderboard__cell leaderboard__cell--title leaderboard__cell--player is-r-score ${stateCss}`}>
            <button
                className="leaderboard__cell-content-title"
                type="button"
                onClick={() => sortingHandlerProps(cellTypes.PLAYER)}
            >
                <div className="leaderboard__cell-title">player</div>
                <div className="leaderboard__cell-title-icon-wrapper">
                    <svg className="leaderboard__cell-title-icon icon" width="9" height="6" focusable="false">
                        <use xlinkHref="#icon-triangle"></use>
                    </svg>
                </div>
            </button>
            {
                view !== viewTypes.HOLE_BY_HOLE &&
                <LeaderboardRScore view={view} toggleRScore={toggleRScore} />
            }

            <div className="leaderboard__cell-title-m">player</div>
        </div>
    );
};

export default LeaderboardCellPlayerTitle;
